import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

export default reducers => {
  const persistedReducer = persistReducer(
    {
      key: "contelerastreador:solicitation",
      storage: storage,
      whitelist: ["auth", "organization"]
    },
    reducers
  );

  return persistedReducer;
};
